import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useData } from "@/context/DataContext";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";
import { NewsCard } from "@/components/cards/NewsCard";

export const NewsSection = ({ limit }) => {
  const { data } = useData();
  const news = (data.news || []).slice(0, limit || undefined);
  if (!news.length) return null;

  return (
    <section data-testid="news-section" className="relative py-24 sm:py-32 bg-[#0A0B0D]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <SectionHeader kicker="Senaste nytt" title="Senaste Nytt" subtitle="Löpande information inför Novemberkåsan 2026." />
            {limit && (
              <Link to="/nyheter" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-amber-500 hover:gap-3 transition-all">
                Alla nyheter <ArrowRight className="w-4 h-4" />
              </Link>
            )}
          </div>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {news.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.08}>
              <NewsCard item={item} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
